import React from 'react';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';

const Step = ({ step }) => {
  return (
    <StepStyled>
      <DivTop>{step}</DivTop>
      <DivBottom />
    </StepStyled>
  );
};

const StepStyled = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  background: transparent;

  & div {
    ${paragraphMixin};
  }
`;
const DivTop = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: var(--ds-c-yellow);
`;
const DivBottom = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: #48443d;
`;

export default Step;
